import { useTranslation } from 'react-i18next';
import type { PricingStrategyProfileResponse } from '@/shared/api';
import type { ProfileComparisonSection } from './profileComparisonRows';
import { formatProfileValue } from './profileValueFormat';

interface Props {
  profiles: PricingStrategyProfileResponse[];
  sections: ProfileComparisonSection[];
}

export function ProfileComparisonCards({ profiles, sections }: Props) {
  const { t } = useTranslation();
  return (
    <div className="@4xl:hidden grid gap-4">
      {profiles.map((profile, profileIndex) => (
        <article key={profile.versionId} className="border-line bg-card min-w-0 rounded-lg border">
          <h4 className="border-line border-b px-4 py-3 font-serif text-lg">
            {t(`admin.dynamicPricing.configuration.strategies.${profile.strategy}`)}
          </h4>
          {sections.map((section) => (
            <section key={section.id} className="border-line border-b p-4 last:border-b-0">
              <h5 className="text-ink-soft mb-2 text-xs font-semibold uppercase tracking-wide">
                {t(`admin.dynamicPricing.profiles.sections.${section.titleKey}`)}
              </h5>
              <dl className="grid gap-2">
                {section.rows.map((row) => (
                  <div
                    key={row.id}
                    className="grid min-w-0 grid-cols-[minmax(0,1fr)_auto] gap-3 text-sm"
                  >
                    <dt className="text-ink-soft min-w-0 break-words">
                      {t(`admin.dynamicPricing.profiles.rows.${row.detailKey}`)}
                    </dt>
                    <dd className="text-ink max-w-32 break-words text-right font-medium tabular-nums">
                      {formatProfileValue(row.values[profileIndex] ?? null, row.format, t)}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </article>
      ))}
    </div>
  );
}
